export enum ObservationListFilterEnum {
    NearMissDateFrom = 'NearMissDateFrom',
    NearMissDateTo = 'NearMissDateTo',
    NearMissConcernLevel = 'NearMissConcernLevel',
    NearMissCategoryId = 'NearMissCategoryId',
    NearMissStatus = 'NearMissStatus',
    NearMissRegionIds = 'NearMissRegionIds',
    NearMissDivisionIds = 'NearMissDivisionIds',
    NearMissDepotPcId = 'NearMissDepotPcId',
    NearMissManagerIds = 'NearMissManagerIds',
    
    GoodPracticeDateFrom = 'GoodPracticeDateFrom',
    GoodPracticeDateTo = 'GoodPracticeDateTo',
    GoodPracticeCategoryId = 'GoodPracticeCategoryId',
    GoodPracticeStatus = 'GoodPracticeStatus',
    GoodPracticeRegionIds = 'GoodPracticeRegionIds',
    GoodPracticeDivisionIds = 'GoodPracticeDivisionIds',
    GoodPracticeDepotPcId = 'GoodPracticeDepotPcId',
    GoodPracticeManagerIds = 'GoodPracticeManagerIds',

    IssueDateFrom = 'IssueDateFrom',
    IssueDateTo = 'IssueDateTo',
    IssueConcernLevel = 'IssueConcernLevel',
    IssueCategoryId = 'IssueCategoryId',
    IssueStatus = 'IssueStatus',
    IssueRegionIds = 'IssueRegionIds',
    IssueDivisionIds = 'IssueDivisionIds',
    IssueDepotPcId = 'IssueDepotPcId',
    IssueManagerIds = 'IssueManagerIds',

    OpportunityDateFrom = 'OpportunityDateFrom',
    OpportunityDateTo = 'OpportunityDateTo',
    OpportunityConcernLevel = 'OpportunityConcernLevel',
    OpportunityCategoryId = 'OpportunityCategoryId',
    OpportunityStatus = 'OpportunityStatus',
    OpportunityRegionIds = 'OpportunityRegionIds',
    OpportunityDivisionIds = 'OpportunityDivisionIds',
    OpportunityDepotPcId = 'OpportunityDepotPcId',
    OpportunityManagerIds = 'OpportunityManagerIds'
}